module.exports = __webpack_public_path__ + "static/1-4ecf6f0f67bc356020a954c322a1b0da.png";